var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-414 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5332",
    "data-name": "Group 5332"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 128,
    height: 128,
    transform: "translate(414 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settings-2",
    "data-name": "settings",
    d: "M119.143,49.342l-9.875-1.255a49.637,49.637,0,0,0-2.989-7.217l6.1-7.853a7.807,7.807,0,0,0-.641-10.395l-8.273-8.273a7.829,7.829,0,0,0-10.426-.667l-7.842,6.1a49.458,49.458,0,0,0-7.222-2.989L76.718,6.933A7.867,7.867,0,0,0,68.913,0H57.147a7.866,7.866,0,0,0-7.805,6.918l-1.255,9.875a48.885,48.885,0,0,0-7.222,2.989l-7.847-6.1a7.814,7.814,0,0,0-10.395.641L14.35,22.591a7.831,7.831,0,0,0-.667,10.432l6.1,7.847a49.058,49.058,0,0,0-2.989,7.217L6.933,49.342A7.867,7.867,0,0,0,0,57.147V68.913a7.866,7.866,0,0,0,6.918,7.805l9.875,1.255a49.636,49.636,0,0,0,2.989,7.217l-6.1,7.853a7.807,7.807,0,0,0,.641,10.395l8.273,8.273a7.835,7.835,0,0,0,10.426.662l7.847-6.1a48.493,48.493,0,0,0,7.217,2.989l1.255,9.854a7.867,7.867,0,0,0,7.805,6.944H68.913a7.866,7.866,0,0,0,7.805-6.918l1.255-9.875a49.636,49.636,0,0,0,7.217-2.989l7.853,6.1a7.807,7.807,0,0,0,10.395-.641l8.273-8.273a7.824,7.824,0,0,0,.667-10.426l-6.1-7.847a48.493,48.493,0,0,0,2.989-7.217l9.854-1.255a7.867,7.867,0,0,0,6.933-7.805V57.147a7.857,7.857,0,0,0-6.912-7.805ZM63.03,89.293A26.263,26.263,0,1,1,89.293,63.03,26.292,26.292,0,0,1,63.03,89.293Z",
    transform: "translate(414.973 528.97)",
    fill: "#90205d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.7245d8a4.svg";
export { ForwardRef as ReactComponent };